import dateService from '@/services/util/dateService'
import loggingService from '@/services/util/loggingService'

var serviceName = 'workflowService'
var path = '/Workflow/'
var isDebug = false

const WorkflowEnum = {
    CaseInitial: 1000,
    Autopsy: 2000,
    Toxicology: 3000,
    MedicalRecords: 4000,
    PharmacyRecords: 5000,
    CaseSummary: 6000
}

const CaseInitialWfStatusEnum = {
    CaseInitiated: 1000,
    CaseRejected: 1100,
    CaseTransferred: 1200,
    PendingWorksheet: 1300,
    VssCompleted: 1350,
    CaseRejectCasefile: 1400,
    RejectedPendingAmend: 1600,
    RejectedAmended: 1650,
    PendingAmendment: 1700,
    Amended: 1750,
    RejectedCompleted: 1800,
    TransferredCountyPublicOffice: 1810,
    Completed: 1900
}

const AutopsyWfStatusEnum = {
    PendingOrder: 2000,
    PendingResults: 2100,
    PendingConsult: 2150,
    PendingFinalResults: 2200,
    PendingAcknowledgement: 2300,
    CompleteOos: 2800,
    Complete: 2900
}

const ToxicologyWfStatusEnum = {
    PendingOrder: 3000,
    PendingResults: 3100,
    Complete: 3900
}

const MedicalRecordsWfStatusEnum = {
    PendingRequest: 4000,
    PendingRecords: 4100,
    Complete: 4900
}

const PharmacyhRecordsWfStatusEnum = {
    PendingRequest: 5000,
    PendingRecords: 5100,
    MedsCollected: 5200,
    Complete: 5900
}

const CaseSummaryWfStatusEnum = {
    PendingCompletion: 6000,
    PendingAmendment: 6800,
    Complete: 6900,
    Amended: 6910
}

function getWorkflowInstanceDto (http, workflowId, parentId) {
    loggingService.log(isDebug, serviceName, 'getWorkflowInstanceDto - workflowId: ' + workflowId + ', parentId: ' + parentId)
    return http.get(path + 'GetWorkflowInstanceDto?workflowId=' + workflowId + '&parentId=' + parentId).then(response => {
        if (response.data) {
            response.data.completeDateFormatted = dateService.toDateTimeString(response.data.completeDate)
            response.data.completeDate = dateService.convertToDate(response.data.completeDate)
        }
        return response
    })
}

function listWorkflowInstanceStatusDto (http, workflowInstanceId) {
    loggingService.log(isDebug, serviceName, 'listWorkflowInstanceStatusDto - workflowInstanceId: ' + workflowInstanceId)

    return http.get(path + 'ListWorkflowInstanceStatusDto?workflowInstanceId=' + workflowInstanceId).then(function (response) {
        for (var i = 0; i < response.data.length; i++) {
            response.data[i].createdDate = dateService.convertToDate(response.data[i].createdDate)
            response.data[i].modifiedDate = dateService.convertToDate(response.data[i].modifiedDate)

            if (response.data[i + 1]) {
                response.data[i].duration = 'about ' + dateService.getDurationHumanized(response.data[i + 1].createdDate, response.data[i].createdDate)
            }
        }

        return response
    })
}

function listNextWorkflowStatus (http, workflowInstanceId) {
    loggingService.log(isDebug, serviceName, 'listNextWorkflowStatus - workflowInstanceId: ' + workflowInstanceId)
    return http.get(path + 'ListNextWorkflowStatus?workflowInstanceId=' + workflowInstanceId)
}

function submit (http, submitDto) {
    loggingService.log(isDebug, serviceName, 'submit')
    return http.post(path + 'Submit', submitDto)
}

function listWorkflowStatusByParent (http, workflowId, parentId) {
    return getWorkflowInstanceDto(http, workflowId, parentId).then(workflowInstanceResult => {
        var workflowInstanceId = workflowInstanceResult.data.workflowInstanceId
        loggingService.log(isDebug, serviceName, 'listWorkflowStatusByParent - workflowInstanceId: ' + workflowInstanceId)
        return listWorkflowInstanceStatusDto(http, workflowInstanceId).then(statusListResult => {
            loggingService.log(isDebug, serviceName, 'listWorkflowStatusByParent - statusList length: ' + statusListResult.data.length)
            return statusListResult
        })
    })
}

function currentWorkflowStatusDto (http, workflowId, parentId) {
    loggingService.log(isDebug, serviceName, 'currentWorkflowStatusDto - workflowId: ' + workflowId + ', parentId: ' + parentId)
    return http.get(path + 'CurrentWorkflowStatusDto?workflowId=' + workflowId + '&parentId=' + parentId)
}

function listAllCurrentWfStatusUnderCase (http, caseId) {
    loggingService.log(isDebug, serviceName, 'listAllCurrentWfStatusUnderCase - caseId: ' + caseId)
    return http.get(path + 'ListAllCurrentWfStatusUnderCase?caseId=' + caseId).then(response => {
        if (response.data) {
            response.data.forEach(item => {
                item.duration = 'about ' + dateService.getDurationHumanized(item.createdDate)
                item.createdDate = dateService.toDateTimeString(item.createdDate)
            })
        }
        return response
    })
}

function listAllWorkflowStatus (http) {
    loggingService.log(isDebug, serviceName, 'listAllWorkflowStatus')
    return http.get(path + 'ListAllWorkflowStatus')
}

function listByWorkflowId (http, workflowId) {
    loggingService.log(isDebug, serviceName, 'listByWorkflowId')
    return http.get(path + 'ListByWorkflowId?workflowId=' + workflowId)
}

function assignCoronerUser (http, wkUserAssignDto) {
    loggingService.log(isDebug, serviceName, 'assignCoronerUser')
    return http.post(path + 'AssignCoronerUser', wkUserAssignDto)
}

export default {
    WorkflowEnum: WorkflowEnum,
    CaseInitialWfStatusEnum: CaseInitialWfStatusEnum,
    AutopsyWfStatusEnum: AutopsyWfStatusEnum,
    ToxicologyWfStatusEnum: ToxicologyWfStatusEnum,
    MedicalRecordsWfStatusEnum: MedicalRecordsWfStatusEnum,
    PharmacyhRecordsWfStatusEnum: PharmacyhRecordsWfStatusEnum,
    CaseSummaryWfStatusEnum: CaseSummaryWfStatusEnum,
    getWorkflowInstanceDto: getWorkflowInstanceDto,
    listWorkflowInstanceStatusDto: listWorkflowInstanceStatusDto,
    listNextWorkflowStatus: listNextWorkflowStatus,
    listWorkflowStatusByParent: listWorkflowStatusByParent,
    currentWorkflowStatusDto: currentWorkflowStatusDto,
    listAllCurrentWfStatusUnderCase: listAllCurrentWfStatusUnderCase,
    submit: submit,
    listAllWorkflowStatus: listAllWorkflowStatus,
    listByWorkflowId: listByWorkflowId,
    assignCoronerUser: assignCoronerUser
}
